import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import IndexPage from './componentes/IndexPage';
import AppPage from './componentes/AppPage';
import AdmPage from './adm/componentes/AdmPage';
import EditAppPage from './adm/componentes/EditAppPage';

import './fontawesome-free-5.0.8/web-fonts-with-css/css/fontawesome-all.css';
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
            <Route exact path="/app/:appId" component={AppPage} />            
            <Route path="/app/:lang/:appId" component={AppPage} />

            <Route exact path="/adm" component={AdmPage} />

            <Route exact path="/adm/app" component={EditAppPage} />
            <Route path="/adm/app/:appId" component={EditAppPage} />

            <Route exact path="/" component={IndexPage} />   
            <Route path="/:lang" component={IndexPage} />
        </Switch>
    </Router> 
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js